// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__qMmJ9","show":"Overlay_show__6pbes","hide":"Overlay_hide__O4cx1","transparentBack":"Overlay_transparentBack__7usO6"};